export default {"src":"/_next/static/image/assets/Illustrations/link.d24e7f0b84ec04545a6fd993e96eb15c.svg","height":24,"width":24};